import { SubscriptionAvailabilityModel } from './../../subscriptionavailabilityrestriction/models/subscriptionavailabilityrestriction.model';
import { AuthService } from './../../shared/models/auth.service';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { SubscriptionModel } from './sharedvehiclegroupsubscription.model';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class SubscriptionService {
  constructor(private authService: AuthService, private http: Http) { }


  public GetSubscriptionList(sharedVehicleGroupHashId: string, input?: DataListModel): Observable<IAPIResponse> {
    let getsubscriptionUrl = WeGoConfig.API_GET_SUBSCRIPTION_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getsubscriptionUrl = getsubscriptionUrl + "?" + queryString + "&sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
    }
    else {
      getsubscriptionUrl = getsubscriptionUrl + "?sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getsubscriptionUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportSubscriptionList(sharedVehicleGroupHashId: string, input?: DataListModel): any {
    input.currentPage = 0;
    let getsubscriptionUrl = WeGoConfig.API_EXPORT_SUBSCRIPTION_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getsubscriptionUrl = getsubscriptionUrl + "?" + queryString + "&sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
    }
    else {
      getsubscriptionUrl = getsubscriptionUrl + "?sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
    }

    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getsubscriptionUrl, options);
  }



  public AddNewSubscription(subscriptionModel: SubscriptionModel): Observable<IAPIResponse> {
    subscriptionModel.freeKilometerInterval = 'MONTHLY';
    subscriptionModel.freeMinuteInterval = 'MONTHLY';
    let body = subscriptionModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_POST_SUBSCRIPTION_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSubscriptionByHashId(subscriptionHashId: string): Observable<IAPIResponse> {
    let getsubscriptionUrl = WeGoConfig.API_GET_SUBSCRIPTION_BY_HASH + "?subscriptionHashId=" + subscriptionHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getsubscriptionUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSubscriptionBasicDetail(
    subscriptionHashId: string
  ): Observable<IAPIResponse> {
    let getsubscriptionBasicDetailUrl =
      WeGoConfig.API_GET_SUBSCRIPTION_BASIC_DETAIL +
      "?subscriptionHashId=" +
      subscriptionHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getsubscriptionBasicDetailUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }


  public DeleteSubsription(subscriptionHashId: string): Observable<IAPIResponse> {
    let getInstanceUrl = WeGoConfig.API_POST_DELETE_SUBSCRIPTION + "?subscriptionHashId=" + subscriptionHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSubscriptionAvailability(sharedVehicleGroupSubscriptionHashId: string, input?: DataListModel): Observable<IAPIResponse> {
    let getsubscriptionUrl = WeGoConfig.API_GET_SUBSCRIPTION_AVAILABILITY;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getsubscriptionUrl = getsubscriptionUrl + "?" + queryString + "&sharedVehicleGroupSubscriptionHashId=" + sharedVehicleGroupSubscriptionHashId;
    }
    else {
      getsubscriptionUrl = getsubscriptionUrl + "?sharedVehicleGroupSubscriptionHashId=" + sharedVehicleGroupSubscriptionHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getsubscriptionUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public AddSubscriptionAvailability(subscriptionAvailabilityModel: SubscriptionAvailabilityModel): Observable<IAPIResponse> {
    let body = subscriptionAvailabilityModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_POST_SUBSCRIPTION_AVAILABILITY, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public DeleteAvailabilityRestriction(selectedIds: string[]): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.post(WeGoConfig.API_DELETE_SUBSCRIPTION_AVAILABILITY, selectedIds, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSubscriptionAvailabilityRestrictionByHashId(availabilityRestriction: string): Observable<IAPIResponse> {
    let getsubscriptionUrl = WeGoConfig.API_GET_SUBSCRIPTION_AVAILABILITY_BY_HASH + "?availabilityRestrictionHashId=" + availabilityRestriction;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getsubscriptionUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportAvailabilityRestrriction(sharedVehicleGroupSubscriptionHashId: string, input?: DataListModel): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getCompanyAdminUrl = WeGoConfig.API_EXPORT_SUBSCRIPTION_AVAILABILITY_LIST + "?" + queryString + "&sharedVehicleGroupSubscriptionHashId=" + sharedVehicleGroupSubscriptionHashId;
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getCompanyAdminUrl, options);
  }

  public GetSubscriptionDropdownList(permissionType: string, organizationHashId: string, sharedVehicleGroupHashId: string): Observable<IAPIResponse> {
    let getSVGListUrl = WeGoConfig.API_GET_DROPDOWN_SUBSCRIPTION_LIST_TEMPLATE;

    if (permissionType) {
      getSVGListUrl = getSVGListUrl + '?permissionType=' + permissionType;
    }

    if (organizationHashId && sharedVehicleGroupHashId) {
      getSVGListUrl = getSVGListUrl + "&organizationHashId=" + organizationHashId + "&sharedVehicleGroupHashId= " + sharedVehicleGroupHashId;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getSVGListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sharedvehiclegroupsubscription/models/sharedvehiclegroupsubscription.service.ts